<template>
    <div class="px-3 py-2" ref="divTable">
        <!-- Head policies (search and buttons)-->
        <div class="py-1">
            <div class="col">
                <Filters 
                    @getData="getData" 
                    @OpenFilters="viewFilters" 
                    @exportDataFile="exportDataFile"
                />
            </div>
        </div>
        <!-- Preloading an table -->
        <placeholder v-if="loading" :type="'table-two'" :count="1"/>
        <TablePoliciesList
            :items="product_scraping_ruleGetter.data"
            :total="product_scraping_ruleGetter.count"
            :current-page="product_scraping_ruleGetter.current_page"
            :page-size="product_scraping_ruleGetter.page_size"
            @edit="updatePolicy"
            @change-page="changePage"
            @change-page-size="changePageSize"
        />
        <!-- Modal -->
        <modal-form
            v-if="propHead.open"
            :propSize="propForm.size"
            :propHead="propHead"
            @closeModal="closeModal"
        >
            <template slot="form">
                <component :is="propForm.form" :propHead="propHead" @refrest="refrest" @getData="getData" :propFilters="propFilters"/>
            </template>
        </modal-form>
        <div class="btn-down bgc-primary-gradient text-dark rounder-50 p-3 cursor-pointer" @click="scroollTo">
            <font-awesome-icon :icon="['fas', 'chevron-up']" />
        </div>
    </div>
</template>
<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
import ExportPolicy from '../policies/export.vue';
import FilterOptions from '../policies/filterOptions.vue';
import Filters from './filters.vue';
import FormPolicy from './form.vue';
import ModalForm from "../../../../components/modal.vue";
import Placeholder from "../../../../components/loadings/placeholder.vue";
import TablePoliciesList from '../policies/table.vue';
import paginationMixin from "../../../../mixins/paginationMixin.js";

export default {
    name: "product-scraping-config",
    mixins: [paginationMixin],
    components: {
        ExportPolicy,
        FilterOptions,
        Filters,
        FormPolicy,
        ModalForm,
        Placeholder,
        TablePoliciesList,
    },
     computed: {
        ...mapGetters([
            "authentication_user",
            "product_scraping_ruleGetter"
        ]),
        paginationState() {
            return this.$store.state.scraping.rules;
        },
    },
    data(){
        return{
            loading: true,
            propHead: {
                action: "",
                open: false,
                module: "scraping",
            },
            propForm: {
                size: "modal-lg",
                form: "",
            },
            marcas: [],
            proveedores: [],
            filtros: [],
            states: [],
            policies: [],
            url: '',
            propFilters: {}
        }
    },
    created(){
        this.getFilterMarca();
        this.getFilterOther();
        this.getFilterState();
        this.getFilterProveedores();
    },
    destroyed() {
        this.reset_filters()
    },
    watch: {
        'authentication_user.client_business_select'(newVal, oldVal) {
            if (newVal !== oldVal) {
                this.loading = false;
                this.reset_filters()
            }
        }
    },
    methods:{
        ...mapActions(["get"]),
        ...mapMutations(['set_filters','reset_filters']),
        /**
         * Handle to create a URL with the filters for get the policy data list
         * @param {String} - URL for get the data (filter component)
         * @return {void}
         */
        getData(url){
            this.loading = true
            this.url = url
            this.get({
                url: this.url,
                mutation: 'product_scraping_rule_list'
            }).then((response) => {
                this.policies = response.results
                this.loading = false
            })
        },
        getFilterProveedores(){
            let url = `/api/products/get_filter_marca/?filter_name=prop_extra_1`
            if(this.authentication_user.client_business_select){
                url += `&client_business=${this.authentication_user.client_business_select.id}`
            }
            this.get({
                url: url
            }).then((response) => {
                this.proveedores = response.results
            })
        },
        getFilterMarca(){
            let url = `/api/products/get_filter_marca/?filter_name=prop_extra_5`
            if(this.authentication_user.client_business_select){
                url += `&client_business=${this.authentication_user.client_business_select.id}`
            }
            this.get({
                url: url
            }).then((response) => {
                this.marcas = response.results
            })
        },
        getFilterOther(){
            this.get({
                url: `/api/products/get_filter_marca/?filter_name=prop_extra_2`
            }).then((response) => {
                this.filtros = response.results
            })
        },
        getFilterState(){
            this.get({
                url: `/api/products/get_filter_marca/?filter_name=prop_extra_3`
            }).then((response) => {
                this.states = response.results
            })
        },
        /**
         * Handle of open the modal view and sets up the necessary properties for the modal.
         * Show the component form-policy
         * 
         * @returns {void}
         */ 
        updatePolicy(row){
            this.propForm.form = 'form-policy'
            this.propForm.size ="modal-xl"
            this.propHead = {
                action: "Actualiza",
                text: "Actualiza las directrices que tus precios deben seguir en comparación con los de tus competidores",
                open: true,
                module: "la política de precios",
                row: row
            }
        },
        /**
         * Opens modal of filter for recomedation.
         * @param {String} componentName - The name of component.
         * @returns {void}
         */ 
        viewFilters(componentName){
            this.propForm.size =""
            this.propForm.form = componentName
            this.propHead = {
                open: true,
                module: "Filtros",
            }  
        },
        /*
        TODO: this function ejetute then of actualizate or create a new register
        * clear the propHead and close modal
        **/
        closeModal() {
            this.propHead = {
                action: "",
                open: false,
                module: "clientes",
            };
            this.propForm.size ="modal-lg"
        },
        refrest(action) {
            if(action === 'createOne' || action === 'actualizate'){
                this.getData(this.url);
            }
            this.closeModal();
        },
        /**
         * Handle of open the modal view with the component and set up the necesaries properties for the modal.
         * Component: export-policy
         * 
         * @return {void} 
         */
        exportDataFile(){
            this.propForm.form = 'export-policy'
            this.propForm.size ="modal-xl"
            this.propFilters = {
                'proveedores' : this.proveedores,
                'filtros' : this.filtros,
                'state' : this.states
            }
            this.propHead = {
                action: "",
                text: "Exporta datos de políticas de precios y asociaciones con competidores",
                open: true,
                module: "Exportar políticas de precios"
            }
        },
        scroollTo() {
            const e = this.$refs.divTable
            e.scrollIntoView({behavior: 'smooth'})
        }
    }
};
</script>
<style scoped>
    .btn{
        padding: 10px 15px !important;
    }
    .btn-down{
        position: fixed;
        bottom: 20px;
        right: 80px;
    }
</style>